module.exports = __webpack_public_path__ + "img/HZ-G1538.c53384e1.jpg";